export default __webpack_public_path__ + "static/media/a7.60323408.png";